export const STORE_TITLE_TEMPLATE = '%s - Babylist Shop'
export const ATTRIBUTE_KEYS = {
  color: 'color',
  style: 'style',
  size: 'size',
}
